<template>
  <div>
    <div class="title">
      <span class="navigation">{{$route.meta.title}}</span>
      <span class="icon">
        <!-- <i class="iconfont icon-sousuo1"></i>   -->
      </span>
    </div>
    <div class="info">
      <div class="info-up">
        <img :src="$store.state.userInfo.avatar | thumbnail(136,136)" class="avatar">
        <div class="info-up-centre">
          <div class="name">{{$store.state.userInfo.name}}</div>
          <div class="mobile">{{$store.state.userInfo.mobile}}</div>
        </div>
        <span class="info-up-right" @click="$router.push('/personal-data')">
          <i class="iconfont icon-bianji1"></i>
        </span>
      </div>
      <div class="info-bottom">{{$store.state.userInfo.introduction}}</div>
    </div>

    <ul class="list">
      <li @click="publicHall">
        <span>
          <i class="iconfont icon-fabu1"></i>
        </span>
        <span class="text">发布的展馆</span>
        <van-icon name="arrow" class="arrow"/>
      </li>
      <!-- <li>
          <span><i class="iconfont icon-shoucang1"></i></span>
          <span class="text">收藏的展馆</span>
          <van-icon name="arrow" class="arrow"/>
        </li>
        <li @click="$router.push('/fans-list')">
          <span><i class="iconfont icon-fensi"></i></span>
          <span class="text">粉丝</span>
          <van-icon name="arrow" class="arrow"/>
      </li>-->
      <li @click="$router.push('/visit-info')">
        <span>
          <i class="iconfont icon-shuju"></i>
        </span>
        <span class="text">用户访问数据</span>
        <van-icon name="arrow" class="arrow"/>
      </li>
    </ul>
    <div class="layout">
      <van-button type="default" class="exit" @click="exit">退出登录</van-button>
    </div>
  </div>
</template>

<script>
import { Icon, Button } from "vant";
import { mapActions } from "vuex";
import store from "@/store";
export default {
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  methods: {
    ...mapActions(["LogOut"]),
    exit() {
      this.LogOut().then(res => {
        this.$router.replace("/login");
      });
    },
    publicHall() {
      this.$router.push({
        path: "/public-hall",
        // 组件公用判断
        query: {
          public: true
        }
      });
    }
  },
  created() {
    store.dispatch("RefreshUserInfo");
  }
};
</script>

<style scoped lang="less">
.title {
  position: relative;
  height: 220px;
  background: url(http://img.tutubox.cn/MyTitleBg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .navigation {
    position: absolute;
    top: 20px;
    left: 15px;
    font-size: 24px;
    font-weight: 800;
    color: rgba(255, 255, 255, 1);
  }
  .icon {
    position: absolute;
    top: 30px;
    right: 15px;
    color: #fff;
    font-size: 20px;
  }
}
.info {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: -133px;
  padding: 20px;
  width: 90%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 1px 6px 21px 0px rgba(66, 83, 103, 0.08);
  .info-up {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .avatar {
      border-radius: 50%;
      width: 68px;
      height: 68px;
      margin-right: 16px;
      vertical-align: middle;
    }
    .info-up-centre {
      padding-top: 10px;
      .name {
        font-size: 18px;
        font-weight: bold;
        color: rgba(54, 54, 54, 1);
        margin-bottom: 16px;
      }
      .mobile {
        font-size: 13px;
        font-weight: 500;
        color: rgba(147, 147, 147, 1);
      }
    }
    .info-up-right {
      margin-left: 30%;
      padding-top: 15px;
    }
  }
  .info-bottom {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(147, 147, 147, 1);
  }
}
.list {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  margin-top: 20px;
  li {
    padding: 18px;
    margin-bottom: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 1px 6px 21px 0px rgba(66, 83, 103, 0.08);
    .iconfont {
      font-size: 18px;
    }
    .text {
      margin-left: 20px;
      font-weight: 500;
      color: rgba(42, 42, 42, 1);
      font-size: 16px;
    }
    .arrow {
      float: right;
      font-size: 18px;
    }
  }
}
.layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .exit {
    font-weight: 500;
    color:rgba(83,83,83,1);
    font-size: 15px;
    margin: 0 auto;
    margin-top: 100px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    background: rgba(221, 221, 221, 1);
    border-radius: 2px;
    box-shadow: 1px 9px 21px 0px rgba(73, 79, 86, 0.06);
  }
}
</style>